import {
  Box,
  Tooltip,
  Typography,
  TypographyProps,
  makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, FC, ReactNode } from 'react';
import { WbCardVariant } from './WbCard';

type WbCardHeaderProps = {
  className?: string;
  style?: CSSProperties;
  contentClassname?: string;
  contentStyle?: CSSProperties;
  titleContentClassname?: string;
  titleContainerStyle?: CSSProperties;
  title: ReactNode;
  icon?: JSX.Element;
  actions?: JSX.Element;
  leading?: JSX.Element;
  typographyProps?: TypographyProps;
  variant?: WbCardVariant;
};

type UseStylesProps = {
  variant: WbCardVariant;
};

const useStyles = makeStyles<any, UseStylesProps>(
  theme => ({
    header: ({ variant }) => {
      const variants = {
        default: {
          background: theme.palette.bkg.primary,
          color: theme.palette.primary.main,
          borderBottom: 'none',
        },
        secondary: {
          background: theme.palette.white,
          color: theme.palette.black,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        },
      };

      return {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        overflowX: 'auto',
        overflowY: 'hidden',
        ...variants[variant],
      };
    },
    headerContent: ({ variant }) => {
      const variants = {
        default: {
          height: '48px',
          padding: '8px 12px',
        },
        secondary: {
          height: '34px',
          padding: '8px 12px',
        },
      };

      return {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        ...variants[variant],
      };
    },
    headerTitleContent: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      flex: '1 1 0',
      overflow: 'hidden',
    },
  }),
  { name: 'WbCardHeader' },
);

export const WbCardHeader: FC<WbCardHeaderProps> = ({
  className,
  style,
  contentClassname,
  contentStyle,
  titleContentClassname,
  titleContainerStyle,
  title,
  icon,
  actions,
  leading,
  typographyProps,
  variant = 'default',
}) => {
  const classes = useStyles({ variant });
  return (
    <Box className={clsx(classes.header, className)} style={style}>
      {leading}
      <Box
        className={clsx(classes.headerContent, contentClassname)}
        style={contentStyle}
      >
        <Box
          className={clsx(classes.headerTitleContent, titleContentClassname)}
          style={titleContainerStyle}
        >
          {typeof title === 'string' ? (
            <Tooltip title={title}>
              <Typography
                variant="h6"
                noWrap
                style={{ fontWeight: 500 }}
                {...typographyProps}
              >
                {title}
              </Typography>
            </Tooltip>
          ) : (
            title
          )}
          {icon}
        </Box>
        {actions}
      </Box>
    </Box>
  );
};
